import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { checkMobileCode } from './request';
import { getPhoneCode } from '@/api/user';
export default {
  props: ['visible'],
  data() {
    return {
      dialogVisible: false,
      dataForm: {
        mobile: '',
        code: '',
        globalRoaming: '+86'
      },
      codeStatus: false,
      phoneCode: this.$t('获取验证码'),
      globalRoamingOptionData: [{
        label: '+86',
        value: '中国大陆',
        code: 'CN'
      }, {
        label: '+886',
        value: '中国台湾',
        code: 'TW'
      }, {
        label: '+852',
        value: '中国香港',
        code: 'HK'
      }, {
        label: '+853',
        value: '中国澳门',
        code: 'MO'
      }, {
        label: '+1',
        value: '美国',
        code: 'US'
      }, {
        label: '+65',
        value: '新加坡',
        code: 'SG'
      }]
    };
  },
  computed: {
    dataRule() {
      return {
        mobile: [{
          required: true,
          trigger: 'blur',
          validator: this.validateMobile
        }],
        code: [{
          required: true,
          message: this.$t('请输入') + this.$t('验证码'),
          trigger: 'blur'
        }]
      };
    }
  },
  watch: {
    visible(newV) {
      this.dialogVisible = newV;
    }
  },
  methods: {
    changeGlobalRoaming(value) {
      this.$set(this.dataForm, 'mobile', '');
      // this.$refs.mobileRef.validateField('mobile');
    },
    validateMobile(rules, value, callback) {
      if (!value) {
        callback(new Error(this.$t('请输入') + this.$t('手机号')));
      } else {
        const regMap = {
          CN: /^1[3456789]\d{9}$/,
          // 中国
          TW: /^09\d{8}$/,
          // 台湾
          HK: /^([6|9])\d{7}$/,
          // 香港
          MO: /^[6]\d{7}$/,
          // 澳门
          US: /^[1-9]\d{9}$/,
          // 美国
          SG: /^[89]\d{7}$/ // 新加坡
        };
        let findItem = this.globalRoamingOptionData.find(item => item.label === this.dataForm.globalRoaming);
        let regValue = regMap[findItem.code];
        if (!regValue.test(value)) {
          callback(new Error(this.$t('手机号码有误，请重新填写')));
        } else {
          callback();
        }
      }
    },
    //关闭修改手机号弹窗
    cancelModal() {
      this.getPhoneIntval && clearInterval(this.getPhoneIntval);
      this.phoneCode = this.$t('获取验证码');
      this.codeStatus = false;
      this.$emit('cancel');
      this.$refs.mobileRef.resetFields();
    },
    //获取验证码
    getCode() {
      this.$refs.mobileRef.validateField('mobile', async err => {
        if (!err) {
          var _this$$refs$code;
          const res = await getPhoneCode({
            mobile: this.dataForm.globalRoaming + this.dataForm.mobile,
            way: 'updatePhone'
          });
          // this.currentCode = res.data;
          this.codeStatus = true;
          let time = 60;
          this.getPhoneIntval = setInterval(() => {
            if (time > 0) {
              time--;
              this.phoneCode = `${this.$t('重新获取')}(${time}s)`;
            } else {
              clearInterval(this.getPhoneIntval);
              this.getPhoneIntval = null;
              this.phoneCode = this.$t('获取验证码');
              this.codeStatus = false;
            }
          }, 1000);
          (_this$$refs$code = this.$refs.code) === null || _this$$refs$code === void 0 || _this$$refs$code.focus();
          // setTimeout(() => {
          //   this.$notification.success(
          //     {
          //       message: '提示',
          //       description: '验证码获取成功，您的验证码为：' + res?.data
          //     },
          //     12
          //   );
          // }, 1000);
        }
      });
    },
    handleSure() {
      this.$refs.mobileRef.validate(async valid => {
        if (valid) {
          await checkMobileCode({
            mobile: this.dataForm.mobile,
            code: this.dataForm.code,
            globalRoaming: this.dataForm.globalRoaming
          });
          this.$message.success(this.$t('操作成功'));
          this.$emit('ok', this.dataForm);
          this.$refs.mobileRef.resetFields();
        }
      });
    }
  }
};